// Curated Oracle built-in functions emitted by `oracleResolver`. Tier 8
// (system-function) so they sit at the bottom of the suggestion list —
// power users still find them via fuzzy match.
//
// Distilled from `oracleLanguageMetadata.ts` ORACLE_FUNCTIONS to avoid
// pulling the legacy completion module's documentation tables onto the
// resolver path. Names only; signature help is delegated to the existing
// Function Signature Help feature once the user opens parens.

const ORACLE_BUILTIN_FUNCTIONS: readonly string[] = [
  // Aggregates
  'COUNT', 'SUM', 'AVG', 'MIN', 'MAX', 'LISTAGG',
  // Null handling
  'NVL', 'NVL2', 'COALESCE', 'NULLIF', 'DECODE',
  // Conversion
  'TO_CHAR', 'TO_NUMBER', 'TO_DATE', 'TO_TIMESTAMP', 'CAST',
  // String
  'SUBSTR', 'INSTR', 'LENGTH', 'REPLACE', 'TRIM', 'UPPER', 'LOWER',
  'INITCAP', 'LPAD', 'RPAD', 'CONCAT',
  // Numeric
  'TRUNC', 'ROUND', 'CEIL', 'FLOOR', 'MOD', 'ABS', 'SIGN', 'POWER', 'SQRT',
  // Date/time
  'SYSDATE', 'SYSTIMESTAMP', 'CURRENT_DATE', 'CURRENT_TIMESTAMP',
  'LOCALTIMESTAMP', 'DBTIMEZONE', 'SESSIONTIMEZONE',
  'ADD_MONTHS', 'MONTHS_BETWEEN', 'LAST_DAY', 'NEXT_DAY', 'EXTRACT',
  // Regex
  'REGEXP_LIKE', 'REGEXP_SUBSTR', 'REGEXP_REPLACE', 'REGEXP_INSTR',
  'REGEXP_COUNT',
  // Window/analytic
  'ROW_NUMBER', 'RANK', 'DENSE_RANK', 'LEAD', 'LAG', 'FIRST_VALUE',
  'LAST_VALUE', 'NTILE',
  // JSON (12c+)
  'JSON_VALUE', 'JSON_QUERY', 'JSON_TABLE',
  // XML
  'XMLAGG',
  // AI Vector Search (Oracle 23ai+) — rejected by 19c and earlier
  'VECTOR_DISTANCE', 'TO_VECTOR', 'VECTOR_SERIALIZE', 'VECTOR_EMBEDDING',
  // Date arithmetic (Oracle 26ai) — SQL Server/MySQL-style helpers
  'DATEDIFF', 'DATEADD',
];

export function getOracleBuiltinFunctions(): readonly string[] {
  return ORACLE_BUILTIN_FUNCTIONS;
}
